<template>
  <v-row align="center" class="fill-height ma-0" justify="center">
    <PcsLogo height="90" class="mt-5"/>
    <ResHubLogo :height="90" :aspectRatio="1"  />
  </v-row>
</template>

<script>
import ResHubLogo from "@/views/login/ResHubLogo.vue";
import PcsLogo from "@/views/login/PcsLogo.vue";

export default {
  components: {
    ResHubLogo, PcsLogo
  },
  props: {
    height: { type: [Number, String], default: null },
    width: { type: [Number, String], default: null },
  }
};
</script>
